export const environment = {
    production: true,
    baseApiURL: 'https://dev-pidb-inmind.com/api/',
    webSocketUrl: 'wss://dev-pidb-inmind.com/',
    authentication: {
        Authority: 'https://login.microsoftonline.com/',
        scopes: ['api://1878ae75-bbe4-4cf4-bb99-26895f12d1b0/userIdentification'],
        TenantId: 'c2b01b86-bce1-48ff-bcc5-456668a69edf',
        ApplicationId: '1878ae75-bbe4-4cf4-bb99-26895f12d1b0',
        redirectUrl: 'https://dev-pidb-inmind.com/home/file-upload',
        logoutRedirectUrl: 'https://dev-pidb-inmind.com',
    },
};
